import React, { useContext } from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { navigate } from 'raviger';
import { SearchForm, Permission } from 'components';
import { I18nContext } from 'i18n';
import { device } from 'utils/device';

const SiteSearch = () => {
  const { translate } = useContext(I18nContext);

  const handleSearch = (values) => {
    navigate('/search/advanced', values);
  };

  return (
    <SiteSearchContainer>
      <Permission
        permission={['scholarships']}
        message={translate('search_permission')}
      >
        <SearchForm onSubmit={handleSearch} />
      </Permission>
    </SiteSearchContainer>
  );
};

const SiteSearchContainer = styled(Container)`
  max-width: 60%;
  padding-top: 10%;

  @media ${device.mobileL} {
    max-width: 95%;
  }
`;

export default SiteSearch;
